export enum MfaAuthTypeEnum {
  NotActivate = 'not_activate',
  Mobile = 'mobile',
  Email = 'email',
}
